import { render, staticRenderFns } from "./proofCosts.vue?vue&type=template&id=406b77fc"
import script from "./proofCosts.vue?vue&type=script&lang=js"
export * from "./proofCosts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports